<div class="main-frame">
    <router-outlet></router-outlet>
</div>
